<script setup>
import { computed, onBeforeMount, reactive, toRefs } from 'vue';
import { commonStore } from '@/store/common';
import { swapStore } from '@/store/swap';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { Toast } from 'vant';

const store = commonStore();
const swap_store = swapStore();
const router = useRouter();
const route = useRoute();
const { locale, t } = useI18n();
const data = reactive({
  show: false,
  LangObj: {},
  showPopover: false,
});
const props = defineProps({
  scrollTop: Number,
});
const { scrollTop } = toRefs(props);
const logo = computed(() =>
  route.name == 'Account' && scrollTop.value < 40
    ? require('@assets/commonImg/logo_white.png')
    : require('@assets/commonImg/logo.png')
);
const toDetails = (item) => {
  if (item.link == 'no') {
    Toast(t('notIn'));
    return;
  }
  if (item.requireAuth && !store.address) {
    // store.initWeb3();
    data.show = false;
    store.setLinkShow(true);
    return;
  }
  data.show = false;
  if (route.path == item.link) {
    return;
  }
  router.push(item.link);
};
const actions = [
  {
    key: 'CN',
    title: '简中',
    icon: require('@assets/commonImg/zh_icon.png'),
  },
  {
    key: 'EN',
    title: 'EN',
    icon: require('@assets/commonImg/en_icon.png'),
  },
  {
    key: 'JA',
    title: 'JP',
    icon: require('@assets/commonImg/ja_icon.png'),
  },
];
const navArr = [
  {
    title: 'Nav.home',
    link: '/home',
    icon: require('@assets/commonImg/icon1.png'),
    requireAuth: false,
  },
  {
    title: 'Nav.market',
    link: '/market',
    icon: require('@assets/commonImg/icon10.png'),
    requireAuth: false,
  },
  {
    title: 'Nav.nft',
    link: '/nft',
    icon: require('@assets/commonImg/icon2.png'),
    requireAuth: true,
  },
  {
    title: 'Nav.exchange',
    link: '/exchange',
    icon: require('@assets/commonImg/icon3.png'),
    requireAuth: true,
  },
  {
    title: 'Nav.account',
    link: '/account',
    icon: require('@assets/commonImg/icon4.png'),
    requireAuth: true,
  },
  {
    title: 'Nav.pledge',
    link: 'no',
    icon: require('@assets/commonImg/icon11.png'),
    requireAuth: false,
  },
  // {
  //   title: '设置',
  //   link: '/set',
  //   icon: require('@assets/commonImg/icon12.png'),
  //   requireAuth: false,
  // },
];
const setInfo = {
  link: '/set',
  requireAuth: true,
};
const toLink = () => {
  if (store.address) {
    store.setAccountShow(true);
    return;
  }
  store.setLinkShow(true);
  // store.initWeb3();
  // swap_store.getTokenMethods();
};
const onSelect = (obj) => {
  // if (obj.key == 'JA') {
  //   Toast(t('notOpen'));
  //   return;
  // }
  data.LangObj = obj;
  locale.value = obj.key;
  data.showPopover = false;
  sessionStorage.setItem('locale', obj.key);
};
onBeforeMount(() => {
  const str = sessionStorage.getItem('locale') || 'EN';
  data.LangObj = actions.find((item) => item.key == str);
});
</script>
<template>
  <div
    class="padding app-nav flex_between"
    :class="[route.name == 'Account' && scrollTop < 40 ? 'tranBg' : 'mainBg']"
  >
    <div class="flex_start">
      <img
        src="@assets/commonImg/nav_icon.png"
        alt=""
        @click="data.show = !data.show"
        class="more_icon"
      />
      <img
        :src="logo"
        @click="toDetails({ link: '/home' })"
        alt=""
        class="logo_icon marginTen"
      />
    </div>

    <div class="flex_end">
      <div class="en_icon">
        <van-popover
          v-model:show="data.showPopover"
          class="allFlex"
          placement="bottom-end"
        >
          <ul class="popver-action">
            <li
              v-for="(item, key) in actions"
              :key="key"
              @click="onSelect(item)"
              class="flex_start padding"
            >
              <img :src="item.icon" alt="" class="en_icon" />
              <span class="marginTen font-Two Wcolor">{{ item.title }}</span>
            </li>
          </ul>
          <template #reference>
            <img src="@assets/commonImg/lang-icon.png" alt="" class="en_icon" />
          </template>
        </van-popover>
      </div>

      <!-- <img
        src="@assets/commonImg/zh_icon.png"
        alt=""
        class="en_icon"
        v-if="locale == 'EN'"
        @click="changeLang('CN')"
      />
      <img
        src="@assets/commonImg/en_icon.png"
        alt=""
        class="en_icon"
        v-if="locale == 'CN'"
        @click="changeLang('EN')"
      /> -->
      <van-button type="primary" size="mini" class="marginTen" @click="toLink"
        >{{
          store.address
            ? store.address.slice(0, 6) + '****' + store.address.slice(-4)
            : $t('Nav.connect')
        }}
      </van-button>
    </div>
  </div>
  <van-popup
    v-model:show="data.show"
    position="left"
    class="nav-popup navBg"
    @click="data.show = !data.show"
    :style="{ width: $i18n.locale == 'JA' ? '120px' : '100px', height: '100%' }"
  >
    <ul class="nav_list Wcolor" @click.stop>
      <li class="nav_close flex_start padding" @click="data.show = !data.show">
        <img src="@assets/commonImg/close_icon.png" alt="" class="close_icon" />
      </li>
      <li
        v-for="(item, key) in navArr"
        :key="key"
        class="center nav_li"
        @click="toDetails(item)"
      >
        <img :src="item.icon" alt="" class="nav_icon" />
        <p class="font-Two Wcolor font500">{{ $t(item.title) }}</p>
      </li>
      <li
        v-if="
          store.address &&
          store.address.toLowerCase() == store.mangerAddr.toLowerCase()
        "
        @click="toDetails(setInfo)"
        class="center nav_li"
      >
        <img src="@assets/commonImg/icon12.png" alt="" class="nav_icon" />
        <span class="font-Two Wcolor font500">提币</span>
      </li>
    </ul>
  </van-popup>
</template>

<style lang="scss" scoped>
.app-nav {
  height: 55px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
  transition: ease-in-out 0.2s;
}
.logo_icon {
  width: 112px;
  height: 25px;
}
.more_icon {
  width: 22px;
  height: 22px;
}
.nav_icon {
  width: 35px;
  height: 35px;
}
.van-button {
  height: 28px;
}
.tranBg {
  background: transparent;
}
.nav_list {
  .nav_li {
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 30px;
  }
  .nav_close {
    height: 60px;
  }
}
.en_icon {
  width: 25px;
  height: 25px;
}
.close_icon {
  width: 22px;
}
.popver-action {
  width: 100px;
  li {
    height: 40px;
  }
}
</style>
